module.exports = __webpack_public_path__ + "img/housingComplex_alone.e2d870c5.png";